
import React, { useCallback, useEffect, useRef, useState } from "react";
import { NewsFeed } from "../../config/imagesLink";
import axios from "../../API/axios";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import ReactQuill from "react-quill";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import AddAPhotoSharpIcon from '@mui/icons-material/AddAPhotoSharp';
import { useTranslation } from "react-i18next";
import useEscapeKeyDown from "../../hooks/useEscapeKeyDown";
const UpdateDraft = ({
    showModal,
    closeModal,
    setDraftJob,
    setDraftPost,
    item,
    postOriginId,
    postOriginType,
    postId,
    setShowModal,
    setPostList,
    draftPostDetail,
    AllPostList,
    DraftPost
}) => {
 

    // console.log("PostOriginType..................", postOriginType, postOriginId);
    const restrictedViewerToken = localStorage.getItem("restrictedViewerToken");
    const { t } = useTranslation();
    const [removedImageIds, setRemovedImageIds] = useState([]); // To track removed image IDs
    const sessionId = localStorage.getItem("sessionId");
    const userUid = localStorage.getItem("userUid");
    const inputFileRef = useRef(null);

    const [postData, setPostData] = useState("");
    const [privacyType, setPrivacyType] = useState(null);
    const [imageNames, setImageNames] = useState("");
    const [selectedImages, setSelectedImages] = useState([]);

    const [images, setImages] = useState([]);
    const [showPost, setShowPost] = useState(false);
    const [display, setDisplay] = useState(false);
    const [postID, setPostID] = useState("");

    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);

    const [warningToastMessage, setWarningToastMessage] = useState("");
    const [showWarningToast, setShowWarningToast] = useState(false);

    const [ErrorToastMessage, setErrorToastMessage] = useState("");
    const [showErrorToast, setShowErrorToast] = useState(false);

    const [postDataItem, setPostDataItem] = useState('') 
    const [postContent, setPostContent] = useState('');
    const language = localStorage.getItem("Lang");
    let mediaFilesImage = postDataItem?.mediaFilesList;

    const [query, setQuery] = useState("");
    const [typingTimeout, setTypingTimeout] = useState(null);
    const [cursorPosition, setCursorPosition] = useState(0); 
    const [postInputValue, setPostInputValue] = useState("");
    const [postDynamicValues, setPostDynamicValues] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [mentionType, setMentionType] = useState("");
    const [SearchText, setSearchText] = useState("");
    const editorRef = useRef(null);
    const [userSelectedImage, setUserSelectedImage] = useState([]);

    // Helper function for regex escaping
    const escapeRegex = (str) => {
        return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    };

    // Helper function to normalize dynamic values from API
    const normalizeDynamicValues = (dynamicValues = []) => {
        return (dynamicValues || []).map((dv, idx) => {
            if (!dv) return null;

            const {
                type,
                dVno,
                entity,
                entityID,
                entityId,
                userUid,
                displayName,
                display,
                entityName,
                hashTag,
            } = dv;

            const resolvedType = type || (hashTag ? "Hashtag" : "UserMention");
            const resolvedDisplayName = displayName ?? display ?? entityName ?? hashTag ?? "";

            let resolvedEntity = entity ?? entityID ?? entityId ?? userUid ?? hashTag ?? resolvedDisplayName;

            if (resolvedType === "Hashtag") {
                resolvedEntity = resolvedDisplayName;
            }

            return {
                type: resolvedType,
                dVno: dVno ?? idx + 1,
                entity: resolvedEntity,
                display: resolvedDisplayName,
                displayName: resolvedDisplayName,
            };
        }).filter(Boolean);
    };

    // Helper function to replace {n} placeholders with @mention/#hashtag
    const replaceDynamicValues = (content, dynamicValues = []) => {
        if (!content) return content;

        let result = content;
        const safeDynamicValues = Array.isArray(dynamicValues) ? dynamicValues : [];

        safeDynamicValues.forEach((item) => {
            const placeholder = `{${item.dVno}}`;
            const displayName = item.display ?? item.displayName ?? "";
            let replacement = "";

            if (item.type === "UserMention" || item.type === "CompanyMention") {
                replacement = `@${displayName}`;
            } else if (item.type === "Hashtag") {
                replacement = `#${displayName}`;
            } else {
                replacement = displayName;
            }

            result = result.replaceAll(placeholder, replacement);
        });

        return result;
    };

    // Helper function to prepare dynamic values for API payload
    const prepareDynamicValuesForPayload = (dyn = []) => {
        return (dyn || []).map((d, idx) => ({
            type: d.type,
            dVno: d.dVno ?? idx + 1,
            entity: d.entity ?? d.entityID ?? d.userUid ?? "",
            displayName: d.display ?? d.displayName ?? "",
        }));
    };

    // Convert mentions to clickable links (for display only)
    const convertMentionsToLinks = (content, dynamicValues) => {
        let modified = content;
        const ensureArray = (val) => (Array.isArray(val) ? val : []);

        ensureArray(dynamicValues).forEach(
            ({ type, displayName, display, entity }) => {
                const prefix =
                    type === "UserMention" || type === "CompanyMention"
                        ? "@"
                        : "#";

                const name = display || displayName;
                const fullText = `${prefix}${name}`;

                const link =
                    type === "UserMention" || type === "CompanyMention"
                        ? `/profile/${entity}`
                        : `/hashtag/${name}`;

                const regex = new RegExp(
                    escapeRegex(fullText) + "(?![^<]*>)",
                    "g"
                );

                modified = modified.replace(
                    regex,
                    `<a href="${link}" target="_blank" class="mention-link">${fullText}</a>`
                );
            }
        );

        return modified;
    };

    const GetPostData = async () => {
        // const data = {
        //     "deviceType": "Web",
        //     // "sessionId": sessionId,
        //     "postId": postId
        // }
        try {
            const resData = await axios.get(`Posts/GetPostInfo?DeviceType=Web&PostId=${postId}&RestrictedViewerToken=${restrictedViewerToken}&langKey=${language}`);
            const postInfoData = resData?.data?.responseData?.postInfo?.postInfo;
            
            console.log("UpdateDraft GetPostData - postContent from API:", postInfoData?.postContent);
            console.log("UpdateDraft GetPostData - dynamicValues from API:", postInfoData?.dynamicValues);
            
            const normalizedDynamicValues = normalizeDynamicValues(postInfoData?.dynamicValues || []);
            const replacedContent = replaceDynamicValues(postInfoData?.postContent || "", normalizedDynamicValues);
            const linkifiedContent = convertMentionsToLinks(replacedContent, normalizedDynamicValues);

            console.log("UpdateDraft GetPostData - Setting postInputValue to:", postInfoData?.postContent);
            console.log("UpdateDraft GetPostData - Setting postDynamicValues to:", normalizedDynamicValues);

            setPostContent(linkifiedContent);
            setPostInputValue(postInfoData?.postContent || "");
            setPostDynamicValues(normalizedDynamicValues);
            setPostDataItem(resData?.data?.responseData?.postInfo);
            setUserSelectedImage(postInfoData?.mediaFilesList || []);
        } catch (error) {
            console.error('UpdateDraft - Error:', error);
        }
    };
 
    


    useEffect(() => { 
        if (showModal && postId) {
            GetPostData();
        }
    }, [showModal, postId])

    // Initialize content from item prop when available
    useEffect(() => {
        // Check both possible structures: item.postInfo or item directly
        const postInfo = item?.postInfo || item;
        
        if (postInfo?.postContent) {
            const rawHtml = postInfo.postContent;

            const normalizedRaw = normalizeDynamicValues(
                postInfo.dynamicValues || []
            );

            const normalized = Array.isArray(normalizedRaw)
                ? normalizedRaw
                : [];

            const replacedContent = replaceDynamicValues(
                rawHtml,
                normalized
            );

            const linkifiedContent = convertMentionsToLinks(
                replacedContent,
                normalized
            );

            setPostContent(linkifiedContent);
            setPostInputValue(rawHtml);
            setPostDynamicValues(normalized);
        }
    }, [item]);


    const handleSubmit = async () => {
        // console.log("postDataItem3333333333",draftPostDetail?.postInfo?.postOriginId );
        
        try {
            const formData = new FormData();
            console.log("formData", formData);
            formData.append("PostId", postId);
            formData.append("DeviceType", "Web");
            formData.append("sessionId", sessionId);
            formData.append("PrivacyType", privacyType === null ? "Public" : privacyType );
            formData.append("PostOriginType", postOriginType);
            formData.append("PostOriginID",postOriginId);

            const imageNameArray = imageNames
                .split(",")
                .filter((name) => name.trim() !== "");

            const containsVideo = (names) => {
                const videoExtensions = [
                    ".mp4",
                    ".webm",
                    ".avi",
                    ".mov",
                    ".mkv",
                    ".flv",
                    ".wmv",
                ];
                return names.some((name) =>
                    videoExtensions.includes(
                        name.slice(name.lastIndexOf(".")).toLowerCase()
                    )
                );
            };

            let postCategory;
            const hasPostContent = postContent !== "";
            const hasImages =
                imageNameArray.length > 0 && !containsVideo(imageNameArray);
            const hasVideos =
                imageNameArray.length > 0 && containsVideo(imageNameArray);

            if (hasPostContent && hasImages && hasVideos) {
                postCategory = "UserStory";
            } else if (hasPostContent && hasImages) {
                postCategory = "UserStory";
            } else if (hasPostContent && hasVideos) {
                postCategory = "UserStory";
            } else if (hasImages && hasVideos) {
                postCategory = "UserStory";
            } else if (hasPostContent) {
                postCategory = "Text";
            } else if (hasImages) {
                postCategory = "Image";
            } else if (hasVideos) {
                postCategory = "Video";
            } else {
                postCategory = "UserStory";
            }
            formData.append("PostCategory", postCategory);
            
            // Prepare dynamic values payload
            const dynamicValuesPayload = prepareDynamicValuesForPayload(postDynamicValues);
            
            // Log data before sending
            console.log("UpdateDraft - About to submit:");
            console.log("postInputValue:", postInputValue);
            console.log("postContent:", postContent);
            console.log("postDynamicValues:", postDynamicValues);
            console.log("dynamicValuesPayload:", dynamicValuesPayload);
            console.log("Final PostContent:", postInputValue || postContent || "");
            
            formData.append("PostContent", postInputValue || postContent || "");
            formData.append(
                "DynamicValues",
                JSON.stringify(dynamicValuesPayload)
            );
            removedImageIds.forEach((id) => {
                formData.append("OldFilesToDelete", id);
            });

            images.forEach((file, index) => {
                formData.append(`FilesToUpload`, file.file);
            })
            formData.append("PostId", postId);
            formData.append("Language",   language === "en" ? "" : language,);

            console.log("FormData entries:");
            for (let pair of formData.entries()) {
                console.log(pair[0] + ': ' + pair[1]);
            }

            const res = await axios.post(`/Posts/UpdatePostDraft?LangKey=${language}`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            console.log("API Response:", res);

            setShowToast(true);
            setToastMessage( res.data.message);
              const postDetailsResponse = 
              await axios.get(
                    `/Posts/GetPostInfo?DeviceType=Web&PostId=${postId}&RestrictedViewerToken=${restrictedViewerToken}&langKey=${language}`
                  );
            const updatedPost = postDetailsResponse?.data?.responseData?.postInfo;

            setDraftPost((prev) =>
            prev.map((post) =>
                post?.postInfo?.postId === updatedPost?.postInfo?.postId
                ? { ...post, postInfo: updatedPost.postInfo }
                : post
            )
            );
            //  DraftPost();
            //    setDraftPost((prev) =>
            //     prev.map((post) => 
            //         post?.postInfo?.postId === updatedPost?.postId
            //         ? {
            //             ...post,                      // keep original outer data
            //             postInfo: {
            //                 ...post.postInfo,           // keep old postInfo values
            //                 ...updatedPost              // merge in new values from API
            //             },
            //             }
            //         : post
            //     )
            //     );

            // DraftPost();
            setTimeout(() => {
                closeModal(); 
            }, 1000); 
        } catch (e) {
            console.error("UpdateDraft Error:", e);
            console.error("Error Response:", e.response);
            
            if (e.response) {
                if (e.response.status === 404) {
                    setWarningToastMessage(e.response.data?.message || "Not found");
                    setShowWarningToast(true);
                } else if (e.response.status === 204) {
                    setWarningToastMessage("No content to update. Please check your input.");
                    setShowWarningToast(true);
                } else if (e.response.status === 400) {
                    setErrorToastMessage(e.response.data?.message || "Bad request - please check your data");
                    setShowErrorToast(true);
                } else {
                    setErrorToastMessage(e.response.data?.message || "An error occurred");
                    setShowErrorToast(true);
                }
            } else {
                setErrorToastMessage("Network error - please try again");
                setShowErrorToast(true);
            }
        }
    };

    const imageSelect = (event) => {
        console.log("image selected", event);
        const selectedFiles = event.target.files;
        console.log("selectedFiles", selectedFiles);
        const newImages = [];

        for (let i = 0; i < selectedFiles.length; i++) {
            const imageName = selectedFiles[i].name;
            if (!checkDuplicate(imageName)) {
                const imageUrl = URL.createObjectURL(selectedFiles[i]);
                newImages.push({
                    name: imageName,
                    url: imageUrl,
                    file: selectedFiles[i],
                });
            } else {
                alert(`${imageName} is already added to the list`);
            }
        }

        setImages((prevImages) => [...prevImages, ...newImages]);
        event.target.value = null; // Reset file input
        console.log("image selected1", images);
    };

    const checkDuplicate = (name) => {
        return images.some((image) => image.name === name);
    };

    console.log('image index', userSelectedImage);

    const userImages = (index) => {
        const removedImage = userSelectedImage[index];
        setRemovedImageIds((prevIds) => [...prevIds, removedImage.pstMid]); // Add removed image ID to the state
        setUserSelectedImage((prevImages) => prevImages.filter((_, i) => i !== index));
    };

    useEffect(() => {
        setUserSelectedImage(postDataItem?.postInfo?.mediaFilesList); // Initialize the state with the media files list
        console.log("useEffect is run");
    }, [postDataItem?.postInfo?.mediaFilesList]);

    console.log("userSelectedImage", userSelectedImage, images);

    const handleShowPost = () => {
        setShowModal(false);
        setShowPost(true);
    };

    const handleClosePost = () => {
        setShowPost(false);
    };
    const mediaFiles = postDataItem?.postInfo?.mediaFilesList?.map((item) => item?.pstMid);

    const handleImageChange = (event) => {
        const files = Array.from(event.target.files);
        const fileNames = files.map((file) => file.name);
        setImageNames(fileNames.join(", "));
        const imageUrls = files.map((file) => URL.createObjectURL(file));
        setSelectedImages((prevImages) => [...prevImages, ...imageUrls]);
    };

    const handleRemoveImage = (index) => {
        setSelectedImages((prevImages) => prevImages.filter((_, i) => i !== index));
        setImageNames((prevNames) => {
            const namesArray = prevNames.split(", ");
            namesArray.splice(index, 1);
            return namesArray.join(", ");
        });
    };

    const renderImages = () => {
        return images.map((image, index) => (
            <div
                key={index}
                className="image_container d-flex justify-content-center position-relative"
            >
                <img src={image.url} alt={image.name} />
                <span className="position-absolute" onClick={() => deleteImage(index)}>
                    &times;
                </span>
            </div>
        ));
    };

    //   const [ userSelectedImages , setUserSelectedImages ] = useState ([]);

    //   setUserSelectedImages(mediaFiles);
    //   console.log("selectedImagesData", mediaFiles);

    const deleteImage = (index) => {
        const updatedImages = [...images];
        updatedImages.splice(index, 1);
        setImages(updatedImages);
    };

    const Privacy = [
        { value: "Public", label: "Public" },
        { value: "Friends", label: "Friends" },
        { value: "OnlyMe", label: "OnlyMe" },
        { value: "Custom", label: "Custom" },
    ];

    // useEffect(() => {
    //     if (inputFileRef.current) {
    //         inputFileRef.current.click();
    //     }
    // }, []);

    const removeImage = (index) => {
        setImages((prevImages) => prevImages.filter((_, i) => i !== index));
    };

    // useEffect(() => {
    //     if (showModal) {
    //         document.body.style.overflow = 'hidden';
    //         document.documentElement.style.overflow = 'hidden';
    //         document.body.classList.add('modal-open'); // When a modal opens
    //     } else {
    //         document.body.style.overflow = 'unset';
    //         document.documentElement.style.overflow = '';
    //         document.body.classList.remove('modal-open'); // When a modal closes
    //     }
    // }, [showModal]);

    const handlePaste = (e) => {
        const isCtrlV = e.ctrlKey && e.key === 'v'; // Check if Ctrl+V was pressed

        if (isCtrlV) {
            e.preventDefault(); // Prevent the default paste action
            alert('Please use Ctrl + Shift + V to paste.'); // Show alert
        }
    };

    // Editor change handler
    const handleChange = (content, delta, source, editor) => {
        if (!editor) return;

        const value = editor.getText();
        const caret = editor.getSelection()?.index || 0;

        if (source !== "user") {
            setPostContent(content);
            return;
        }

        console.log("UpdateDraft handleChange - Text value:", value);
        console.log("UpdateDraft handleChange - HTML content:", content);

        setPostContent(content);
        setCursorPosition(caret);
        detectTrigger(value, caret);

        const safeDynamicValues = Array.isArray(postDynamicValues) ? postDynamicValues : [];
        console.log("UpdateDraft handleChange - Current dynamic values:", safeDynamicValues);

        const updatedDynamicValues = safeDynamicValues.filter(({ type, displayName, display }) => {
            const prefix = type === "UserMention" || type === "CompanyMention" ? "@" : "#";
            const name = display || displayName;
            return value.includes(`${prefix}${name}`);
        });

        const reassignedDynamicValues = updatedDynamicValues.map((item, index) => ({
            ...item,
            dVno: index + 1
        }));

        setPostDynamicValues(reassignedDynamicValues);

        const quillInstance = editorRef.current?.getEditor?.();
        const htmlContent = quillInstance?.root?.innerHTML || "";

        console.log("UpdateDraft handleChange - HTML for conversion:", htmlContent);
        console.log("UpdateDraft handleChange - Reassigned dynamic values:", reassignedDynamicValues);

        const updatedPostInputValue = updatePostInputValueWithDynamicValues(htmlContent, reassignedDynamicValues);

        console.log("UpdateDraft handleChange - Final postInputValue:", updatedPostInputValue);

        setPostInputValue(updatedPostInputValue);
    };
    
    const updatePostInputValueWithDynamicValues = (rawContent, dynamicValues) => {
        let modifiedText = rawContent;

        console.log("updatePostInputValueWithDynamicValues - Input:", rawContent);
        console.log("updatePostInputValueWithDynamicValues - Dynamic values:", dynamicValues);

        dynamicValues.forEach(({ type, dVno, displayName, display }) => {
            const prefix = type === "UserMention" || type === "CompanyMention" ? "@" : "#";
            const name = display || displayName;
            const fullMention = `${prefix}${name}`;
            const regex = new RegExp(
                `${escapeRegex(fullMention)}(?=\\s|&nbsp;|<|$)`,
                "gi"
            );
            console.log(`Replacing "${fullMention}" with "{${dVno}}"`);
            modifiedText = modifiedText?.replace(regex, `{${dVno}}`);
        });

        console.log("updatePostInputValueWithDynamicValues - Output:", modifiedText?.trim());

        return modifiedText?.trim();
    };
    
      // Detect @ or #
      const detectTrigger = (value, caret) => {
        const textBeforeCursor = value?.slice(0, caret);
        const match = textBeforeCursor.match(/([@#])(\w*)$/);
        if (match) {
          const trigger = match[1];
          const q = match[2];
          setMentionType(trigger === "@" ? "UserMention" : "Hashtag");
          setQuery(q);
          fetchSuggestions(q, trigger);
          setSearchText(q)
        } else {
          // setShowSuggestions(false);
          setSearchText('')
        }
      };
    
      const fetchSuggestions = async (searchText, triggerChar) => {
        const data = {
          deviceType: "Web",
          sessionId: sessionId,
          langKey: language === "en" ? "" : language,
        };
    
        try {
          if (triggerChar === "@") {
            const res = await axios.post(`General/MentionTagDDL?Search=${searchText}`, data);
            const results = res.data.responseData || [];
            setSuggestions(results);
            setShowSuggestions(results.length > 0);
          } else if (triggerChar === "#") {
            const res = await axios.post(`General/HashtagDDL?SearchHashtag=${searchText}`, data);
            const results = res.data.responseData || [];
            setSuggestions(results);
            setShowSuggestions(results.length > 0);
          }
        } catch (err) {
          console.error(err);
          if (triggerChar === "#" && searchText) {
            setShowSuggestions(true);
          } else {
            setShowSuggestions(false);
          }
        }
      };
    
    const insertMention = (suggestion, userUid, entityType) => {
        const quill = editorRef.current?.getEditor?.();
        if (!quill) return;

        const cursorPosition = quill.getSelection()?.index || 0;
        const textBeforeCursor = quill.getText(0, cursorPosition);
        const match = textBeforeCursor.match(/[@#]\w*$/);
        if (!match) return;

        const startIndex = cursorPosition - match[0].length;

        const isUser =
            mentionType === "UserMention" ||
            entityType === "CompanyMention";

        const prefix = isUser ? "@" : "#";
        const displayName = suggestion?.trim();

        if (!displayName) return;

        const mentionText = `${prefix}${displayName}`;

        // Remove partial typed text
        quill.deleteText(startIndex, match[0].length);

        quill.insertText(startIndex, mentionText, "user");

        quill.insertText(startIndex + mentionText.length, " ");
        quill.setSelection(startIndex + mentionText.length + 1);

        // -------- Dynamic Value --------
        const safeDynamicValues = Array.isArray(postDynamicValues)
            ? postDynamicValues
            : [];

        const dVno = safeDynamicValues.length + 1;

        const newDynamicValue = {
            type: isUser ? entityType || "UserMention" : "Hashtag",
            dVno,
            entity: isUser ? userUid : displayName,
            display: displayName,
        };

        const updatedValues = [...safeDynamicValues, newDynamicValue];

        setPostDynamicValues(updatedValues);

        // Safe HTML access
        const quillInstance = editorRef.current?.getEditor?.();
        const editorHtml = quillInstance?.root?.innerHTML || "";

        const updatedInputValue =
            updatePostInputValueWithDynamicValues(
                editorHtml,
                updatedValues
            );

        setPostInputValue(updatedInputValue);

        setShowSuggestions(false);
        setSearchText('');
    };

    const handleUpdateDraftEscape = useCallback(() => {
        if (showSuggestions) {
            setShowSuggestions(false);
            return;
        }
        closeModal();
    }, [showSuggestions, closeModal]);

    useEscapeKeyDown(showModal, handleUpdateDraftEscape);

    return (
        <>
            {showModal && (
                <div
                    className="modal fade show postAdd"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: "block" }}
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content p-2">
                            <div className="modalBorder d-flex justify-content-between align-items-center">
                                <h6>{t("Newsfeed.Update")} {t("Drafts.Post Drafts")}</h6>
                                <CloseSharpIcon
                                    className="material-symbols-sharp me-2 pointer"
                                    onClick={closeModal}
                                />
                            </div>
                            {/* <div className="d-flex align-items-center m-3 pb-3 modalBorder ">
                                <div className="ImgAvatar">
                                    <img src={postDataItem?.userAvatar} alt="" style={{ borderRadius: '50%' }} />
                                </div>
                                <p className="f-16 AddPost ms-2">What's on your mind?</p>
                            </div> */}
                            <div className="m-3"> 
                                <ReactQuill
                                    value={postContent}
                                    ref={editorRef}
                                    // onChange={setPostContent}
                                     onChange={(content, delta, source, editor) => {
                                    handleChange(content, delta, source, editor);
                                    }}
                                    onKeyDown={handlePaste} // Use onKeyDown to detect key presses
                                    placeholder={t("Drafts.Update Post")}
                                    // modules={{
                                    //   toolbar: [
                                    //     [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
                                    //     [{ size: [] }],
                                    //     ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                    //     [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
                                    //     ['link'],
                                    //     ['clean']
                                    //   ]
                                    // }}
                                    modules={{
                                        toolbar: false, // Hide the toolbar
                                    }}
                                    formats={[
                                        'header', 'font', 'size',
                                        'bold', 'italic', 'underline', 'strike', 'blockquote',
                                        'list', 'bullet', 'indent',
                                        'link'
                                    ]}
                                />
                                 {showSuggestions && (
                                        <ul className="suggestion-box">
                                        {mentionType === "Hashtag" ? <li
                                            onMouseDown={(e) => {
                                            e.preventDefault(); // Prevent editor blur
                                            insertMention(
                                                SearchText,
                                                null,
                                                null
                                            );
                                            }}
                                            className="suggestion-item"
                                        >
                                            <span>{SearchText ? `#${SearchText}` : ''}</span>
                                        </li> : null}
                                        {suggestions?.map((item, index) => (
                                            <li
                                            key={index}
                                            onMouseDown={(e) => {
                                                e.preventDefault(); // Prevent editor blur
                                                insertMention(
                                                mentionType === "UserMention" ? item?.entityName : item?.hashTag,
                                                mentionType === "UserMention" ? item?.userUid : null,
                                                mentionType === "UserMention" ? item?.entityType : null
                                                );
                                            }}
                                            className="suggestion-item"
                                            >
                                            {mentionType === "UserMention" ? (
                                                <>
                                                <img
                                                    src={item?.avatar}
                                                    alt={item?.entityName}
                                                    className="avatar"
                                                />
                                                <span>{item?.entityName}</span>
                                                </>
                                            ) : (
                                                <span>#{item?.hashTag}</span>
                                            )}
                                            </li>
                                        ))}
                                        </ul>
                                    )}
                            </div>

                            <div className="modal-border d-flex justify-content-center align-items-center">
                                <input
                                    id="fileInput"
                                    type="file"
                                    onChange={imageSelect}
                                    style={{ display: "none" }}
                                    ref={inputFileRef}
                                    multiple
                                />

                                {images?.length > 0 && (
                                    <div className="post-selected d-flex justify-content-center flex-wrap">
                                        {images?.map((image, index) => (
                                            <div key={index} className="position-relative m-2">
                                                <img
                                                    src={image.url}
                                                    alt={`Selected Image ${index}`}
                                                    style={{
                                                        maxWidth: "200px",
                                                        maxHeight: "300px",
                                                        objectFit: "cover",
                                                    }}
                                                />
                                                <button
                                                    onClick={() => removeImage(index)}
                                                    className="btn btn-danger position-absolute top-0 end-0"
                                                    style={{
                                                        transform: "translate(50%, -50%)",
                                                        borderRadius: "50%",
                                                        width: "24px",
                                                        height: "24px",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        padding: "0",
                                                    }}
                                                >
                                                    &times;
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {userSelectedImage?.length > 0 && (
                                <div className="post-selected d-flex justify-content-center flex-wrap">
                                    {userSelectedImage.map((imageUrl, index) => (
                                        <div key={index} className="position-relative m-2">
                                            <img
                                                src={imageUrl.mediaName}
                                                alt={`Selected Image ${index}`}
                                                style={{
                                                    maxWidth: "200px",
                                                    maxHeight: "300px",
                                                    objectFit: "cover",
                                                }}
                                            />
                                            <button
                                                onClick={() => userImages(index)}
                                                className="btn btn-danger position-absolute top-0 end-0"
                                                style={{
                                                    transform: "translate(50%, -50%)",
                                                    borderRadius: "50%",
                                                    width: "24px",
                                                    height: "24px",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    padding: "0",
                                                }}
                                            >
                                                &times;
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}

                            <div className="m-3 mb-1 d-flex align-items-center">


                                <form className="form" action="#" method="post" id="form">
                                    <input
                                        type="file"
                                        name="Image"
                                        id="image"
                                        multiple
                                        className="d-none"
                                        onChange={imageSelect}
                                    />
                                    <AddAPhotoSharpIcon
                                        className="material-symbols-sharp me-2 mt-2 pointer"
                                        onClick={() => inputFileRef.current.click()} // Trigger the file input click
                                    />
                                </form>


                                <button className="mainBtn ms-auto" onClick={() => {
                                    handleSubmit()
                                    // setToastMessage("Post draft updated successfully!");
                                    // setShowToast(true);
                                }}>
                                {t("Newsfeed.Update")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
            />

            <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
            />

            <ErrorToast
                show={showErrorToast}
                message={ErrorToastMessage}
                onClose={() => setShowErrorToast(false)}
            />
        </>
    );
};

export default UpdateDraft;
